import css from 'styled-jsx/css';

const YoutubeVideoStyles = css`
  .youtube-video {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .youtube-video iframe {
    width: 100%;
    height: 100%;
    max-width: 100%;
  }

  .youtube-video-mobile {
    pointer-events: none;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .youtube-video-mobile iframe {
    width: 100%;
    height: 100%;
  }
`;

export { YoutubeVideoStyles };
